<sim-base-chip-input
	[formState]="mediaSetFc"
	[label]="label"
	[placeholder]="placeholder"
	[isMultiSelect]="canSelectMultipleMediaSets"
	[autoCompleteValues]="autoCompleteData"
	[debounceConfig]="{time: 200}"
	(searchFieldChanged)="reloadAutoCompleteData($event)"
	(optionSelected)="optionSelected.emit($event)"
>
	<ng-container labelSuffix>
		<ng-content select="[labelSuffix]" />
	</ng-container>
</sim-base-chip-input>
